import React from 'react';
import { X } from 'lucide-react';

// Session type labels per scenario per MD-day
export const SESSION_LABELS = {
  '1A': { 'MD+1':'Vrij', 'MD+2':'Opstart', 'MD+3':'VCT gr', 'MD+4':'VCT kl', 'MD-3':'Vrij', 'MD-2':'TT*', 'MD-1':'Scherp', 'MD':'' },
  '1B': { 'MD+1':'Herstel WVP', 'MD+2':'Vrij', 'MD+3':'Opstart', 'MD+4':'VCT kl+gr', 'MD-3':'Vrij', 'MD-2':'TT*', 'MD-1':'Scherp', 'MD':'' },
  '1C': { 'MD+1':'Vrij', 'MD+2':'Opstart', 'MD+3':'VCT kl+gr', 'MD+4':'Vrij', 'MD-3':'TT 1', 'MD-2':'TT 2*', 'MD-1':'Scherp', 'MD':'' },
  '1D': { 'MD+1':'Herstel WVP', 'MD+2':'Vrij', 'MD+3':'Opstart', 'MD+4':'VCT kl+gr', 'MD-4':'Vrij', 'MD-3':'TT 1', 'MD-2':'TT 2*', 'MD-1':'Scherp', 'MD':'' },
  '1E': { 'MD+1':'Herstel WVP', 'MD+2':'Opstart', 'MD+3':'VCT kl+gr', 'MD-2':'TT 1', 'MD-1':'TT 2*', 'MD':'' },
  '2A': { 'MD+1':'Vrij', 'MD+2':'Opstart', 'MD+3':'VCT kl+gr', 'MD-3':'Vrij', 'MD-2':'TT*', 'MD-1':'Scherp', 'MD':'' },
  '2B': { 'MD+1':'Herstel WVP', 'MD+2':'Vrij', 'MD+3':'Opstart', 'MD-3':'VCT kl+gr', 'MD-2':'TT**', 'MD-1':'Scherp', 'MD':'' },
  '2C': { 'MD+1':'Herstel WVP', 'MD+2':'Vrij', 'MD+3':'Opstart', 'MD-3':'VCT kl+gr*', 'MD-2':'Herstel', 'MD-1':'Scherp', 'MD':'' },
  '3A': { 'MD+1':'Vrij', 'MD+2':'Opstart', 'MD+3':'VCT kl+gr', 'MD-2':'TT**', 'MD-1':'Scherp', 'MD':'' },
  '3B': { 'MD+1':'Herstel WVP', 'MD+2':'Vrij', 'MD+3':'Opstart', 'MD-2':'TT**', 'MD-1':'Scherp', 'MD':'' },
  '3C': { 'MD+1':'Herstel WVP', 'MD+2':'Opstart', 'MD+3':'Vrij', 'MD-2':'TT*', 'MD-1':'Scherp', 'MD':'' },
  '3D': { 'MD+1':'Herstel WVP', 'MD+2':'Opstart', 'MD+3':'VCT kl+gr', 'MD-2':'Vrij', 'MD-1':'Scherp', 'MD':'' },
  '4A': { 'MD+1':'Vrij', 'MD+2':'Opstart', 'MD-2':'TT**', 'MD-1':'Scherp', 'MD':'' },
  '4B': { 'MD+1':'Vrij', 'MD+2':'Opstart', 'MD+3':'Scherp', 'MD+4':'VCT kl+gr', 'MD':'' },
  '4C': { 'MD+1':'Herstel WVP', 'MD+2':'Vrij', 'MD-2':'TT**', 'MD-1':'Scherp', 'MD':'' },
  '5A': { 'MD+1':'Vrij', 'MD+2':'Opstart', 'MD-1':'Scherp', 'MD':'' },
  '6A': { 'MD-2':'Herstel TT/WVP', 'MD-1':'Scherp', 'MD':'' },
  '6B': { 'MD+1':'Vrij', 'MD-1':'Scherp', 'MD':'' },
};

const MAIN_GROUP   = ['1A','1B','2A','2B','3A','3B','4A','5A'];
const OVERIGE_GROUP = ['1C','1D','1E','2C','3C','3D','4B','4C','6A','6B'];

function getCellStyle(label) {
  if (label === '') return { bg: '#dc2626', border: '#ef4444', text: '#fecaca', bold: true };
  if (label && label.includes('VCT')) return { bg: '#d97706', border: '#f59e0b', text: '#1c1917', bold: true };
  if (label === 'Vrij') return { bg: '#1e3a5f', border: 'var(--border-strong)', text: '#7dd3fc', bold: false };
  return { bg: 'var(--border)', border: 'var(--border-strong)', text: 'var(--text-primary)', bold: false };
}

export function ScenarioGrid({ title, names, scenarioDays, allLabels, compact, highlightDay }) {
  const maxCols = Math.max(1, ...names.map(n => (scenarioDays[n] || []).length));
  const cellMinW = compact ? 56 : 74;
  const cellMaxW = compact ? 68 : 90;
  const pad = compact ? '3px 5px' : '5px 8px';
  const fontSize = compact ? 9 : 10;

  return (
    <div style={{ marginBottom: compact ? 14 : 28 }}>
      {title && (
        <div style={{
          fontSize: 11, fontWeight: 700, color: 'var(--text-muted)', marginBottom: 10,
          textTransform: 'uppercase', letterSpacing: '0.08em',
        }}>{title}</div>
      )}
      <div style={{ overflowX: 'auto' }}>
        <table style={{ borderCollapse: 'separate', borderSpacing: '3px 3px' }}>
          <tbody>
            {names.map(name => {
              const days = scenarioDays[name] || [];
              const labels = allLabels[name] || {};
              return (
                <tr key={name}>
                  <td style={{
                    padding: '0 12px 0 0', fontWeight: 700, color: 'var(--text-secondary)',
                    fontSize: compact ? 12 : 14, whiteSpace: 'nowrap', verticalAlign: 'middle',
                    minWidth: compact ? 34 : 42,
                  }}>{name}</td>

                  {days.map((day, i) => {
                    const label = labels[day];
                    const s = getCellStyle(label);
                    const isHighlighted = highlightDay && day === highlightDay;
                    return (
                      <td key={i} style={{ padding: 0, verticalAlign: 'top' }}>
                        <div style={{
                          background: s.bg,
                          border: isHighlighted ? '2px solid #3b82f6' : `1px solid ${s.border}`,
                          borderRadius: 5,
                          padding: pad,
                          minWidth: cellMinW,
                          maxWidth: cellMaxW,
                          textAlign: 'center',
                          boxShadow: isHighlighted ? '0 0 0 2px rgba(59,130,246,0.35)' : 'none',
                        }}>
                          <div style={{
                            fontSize, fontWeight: 700, color: s.text,
                            textDecoration: 'underline', marginBottom: 2,
                            whiteSpace: 'nowrap',
                          }}>{day}</div>
                          <div style={{
                            fontSize, color: s.text,
                            fontWeight: s.bold ? 700 : 500,
                            lineHeight: 1.3,
                            wordBreak: 'break-word',
                          }}>
                            {label === '' ? 'MD' : (label ?? '—')}
                          </div>
                        </div>
                      </td>
                    );
                  })}

                  {Array.from({ length: maxCols - days.length }).map((_, i) => (
                    <td key={`pad-${i}`} style={{ minWidth: compact ? 60 : 80 }} />
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default function ScenarioMapModal({ scenarioDays, customTemplates, onClose }) {
  const customNames = (customTemplates || []).map(t => t.name);
  const allLabels = {
    ...SESSION_LABELS,
    ...Object.fromEntries((customTemplates || []).map(t => [t.name, t.labels || {}])),
  };

  const mainNames    = MAIN_GROUP.filter(n => scenarioDays[n]);
  const overigeNames = OVERIGE_GROUP.filter(n => scenarioDays[n]);
  const customValid  = customNames.filter(n => !MAIN_GROUP.includes(n) && !OVERIGE_GROUP.includes(n) && scenarioDays[n]);

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.78)', zIndex: 1100,
        display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
        padding: '32px 16px', overflowY: 'auto',
      }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        background: 'var(--bg-app)', borderRadius: 14, padding: '28px 32px',
        width: '100%', maxWidth: 1000, border: '1px solid var(--border-strong)',
        boxShadow: '0 25px 60px rgba(0,0,0,0.55)', position: 'relative',
      }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 22 }}>
          <div>
            <h2 style={{ fontSize: 18, fontWeight: 700, color: 'var(--text-primary)', margin: 0 }}>Scenario Overview</h2>
            <p style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>Session structure for all available training scenarios</p>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)', padding: 4 }}>
            <X size={18} />
          </button>
        </div>

        {/* Legend */}
        <div style={{ display: 'flex', gap: 20, marginBottom: 24, flexWrap: 'wrap' }}>
          {[
            { bg: '#d97706', label: 'VCT — High intensity' },
            { bg: '#dc2626', label: 'MD — Match day' },
            { bg: '#1e3a5f', label: 'Vrij / Herstel — Rest / Recovery' },
            { bg: 'var(--border)', label: 'Training (TT, Scherp, Opstart)' },
          ].map(({ bg, label }) => (
            <div key={label} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <div style={{ width: 12, height: 12, background: bg, borderRadius: 3, border: '1px solid var(--border-strong)' }} />
              <span style={{ fontSize: 11, color: 'var(--text-secondary)' }}>{label}</span>
            </div>
          ))}
        </div>

        <ScenarioGrid title="Scenario's" names={mainNames} scenarioDays={scenarioDays} allLabels={allLabels} />
        {overigeNames.length > 0 && (
          <ScenarioGrid title="Overige scenario's" names={overigeNames} scenarioDays={scenarioDays} allLabels={allLabels} />
        )}
        {customValid.length > 0 && (
          <ScenarioGrid title="Custom scenarios" names={customValid} scenarioDays={scenarioDays} allLabels={allLabels} />
        )}
      </div>
    </div>
  );
}
